import { hideableValueCreateHidden } from "@wix/devzai-utils-common";
import type { HideableValue } from "@wix/devzai-utils-common";
import {bymoTemplateMetadataFactoryCreate} from '../../../doppe-sdk';
import type {BymoPageHasSearchProps, BymoPageSocialLinksProps} from '../../../client-server-common';
import {
    BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    BymoPagePropsSpecialContentSettingMetadata,
    bymoPagePropsCreateContentSettingMetadata
} from '../../../client-server-common';
import {
    BymoTemplateSpeedDialActionsListAppearance,
    BymoTemplateSpeedDialAutoComplete,
    BymoTemplateSpeedDialHeaderAppearance,
    BymoTemplateSpeedDialSearchAppearance,
    BymoTemplateSpeedDialSocialLinksAppearance
} from './bymo-template-speed-dial-common';

export namespace BymoTemplateSpeedDial {

    export interface TemplateProps extends BymoPageSocialLinksProps , BymoPageHasSearchProps {
        autoCompleteBehaviour: BymoTemplateSpeedDialAutoComplete;
        showFullScreenAutoCompleteOnMobile: boolean;
        actionsHeading: HideableValue<string>;
        actionsListAppearance: BymoTemplateSpeedDialActionsListAppearance;
        bioText: HideableValue<string>;
        bioTextMaxLines: HideableValue<number>;
        headerAppearance: BymoTemplateSpeedDialHeaderAppearance;
        socialLinksAppearance: BymoTemplateSpeedDialSocialLinksAppearance;
    }
}

const TemplatePropsDefaultValues = () => {
    return {
        autoCompleteBehaviour: BymoTemplateSpeedDialAutoComplete.OnInputSearch as BymoTemplateSpeedDialAutoComplete,
        showFullScreenAutoCompleteOnMobile: false,
        showActionsInSearch: false,
        showLinksInSearch: true,
        actionsHeading: '',
        bioText: '',
        actionsListAppearance: BymoTemplateSpeedDialActionsListAppearance.Visible as BymoTemplateSpeedDialActionsListAppearance,

        socialLinks: [],
        bioTextMaxLines: hideableValueCreateHidden(3),
        searchAppearance: BymoTemplateSpeedDialSearchAppearance.Hidden ,
        searchPlaceholder: hideableValueCreateHidden(""),
        headerAppearance: BymoTemplateSpeedDialHeaderAppearance.Default ,
        socialLinksAppearance: BymoTemplateSpeedDialSocialLinksAppearance.Default ,
    } as BymoTemplateSpeedDial.TemplateProps;
}


export const BymoTemplateSpeedDialTemplateMetadata = bymoTemplateMetadataFactoryCreate<BymoTemplateSpeedDial.TemplateProps>()({
    initialValues: TemplatePropsDefaultValues(),
    resolveProps: props => {
      const {
            ...restProps
        } = props;

        return {
            ...TemplatePropsDefaultValues(),
            socialLinksAppearance: BymoTemplateSpeedDialSocialLinksAppearance.Default,
            ...restProps
        }
    },
    templatePropsMetadata: {
        bioText: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
        actionsHeading: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
        searchPlaceholder: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
        bioTextMaxLines: BymoPagePropsSpecialContentSettingMetadata.Ignored,
    },
    features: [
        'hasActionButton',
        'hasProfileContent',
        'hasVisibleBackground',
        'hasCustomTextualContent',
        'hasActions',        // ✅ Single-page support
        'canBeSkipped',
    ]
})